import React from 'react'

const paths = {
  book: <><path d="M4 4.5c2.7-1.2 5.3-1.1 8 0v15c-2.7-1.1-5.3-1.2-8 0zM12 4.5c2.7-1.1 5.3-1.2 8 0v15c-2.7-1.2-5.3-1.1-8 0z"/></>,
  presentation: <><rect x="3" y="3" width="18" height="13" rx="2"/><path d="M12 16v5m-5 0h10M7 8h10M7 11h6"/></>,
  create: <><path d="M4 20h16M5 15l9-9 4 4-9 9-4 1zM16 4l4 4"/></>,
  folder: <><path d="M3 6h7l2 2h9v11H3z"/></>,
  history: <><path d="M3 11a9 9 0 1 1 1.6 5M3 4v7h7M12 7v5l3 2"/></>,
  users: <><circle cx="9" cy="8" r="3"/><path d="M3.5 20v-2a5.5 5.5 0 0 1 11 0v2zM17 5a3 3 0 0 1 0 6m1 4a5 5 0 0 1 3 5"/></>,
  template: <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 9v12M13 13h5M13 17h5"/></>,
  jobs: <><rect x="4" y="4" width="16" height="17" rx="2"/><path d="M8 2v4m8-4v4M8 11h8m-8 4h5"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3M4.9 4.9 7 7m10 10 2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"/></>,
  bell: <><path d="M5 17h14l-2-3V9a5 5 0 0 0-10 0v5zM10 21h4"/></>,
  chevronDown: <path d="m5 9 7 7 7-7"/>,
  chevronLeft: <path d="m15 4-8 8 8 8"/>,
  chevronRight: <path d="m9 4 8 8-8 8"/>,
  trash: <><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5m4-5v5"/></>,
  copy: <><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></>,
  undo: <><path d="M9 7 4 12l5 5M4 12h10a6 6 0 0 1 0 12"/></>,
  redo: <><path d="m15 7 5 5-5 5m5-5H10a6 6 0 0 0-6 6"/></>,
  pdf: <><path d="M6 2h9l4 4v16H6zM15 2v5h4M9 12h6M9 16h6"/></>,
  pptx: <><path d="M5 3h14v18H5zM9 8h4a2 2 0 0 1 0 4H9zM9 8v9"/></>,
  imageLeft: <><rect x="3" y="5" width="7" height="14" rx="1"/><path d="M13 7h8m-8 4h8m-8 4h6"/></>,
  imageRight: <><rect x="14" y="5" width="7" height="14" rx="1"/><path d="M3 7h8m-8 4h8m-8 4h6"/></>,
  imageNone: <><path d="M3 7h18M3 12h18M3 17h14"/></>,
  logout: <><path d="M10 4H4v16h6M14 8l4 4-4 4m4-4H9"/></>,
}

export default function AppIcon({ name, size = 20, className = '' }) {
  return <svg className={`app-icon ${className}`} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.folder}</svg>
}
